import KindEditor from '../components/Component/KindEditor/Index'
const install = function(Vue) {
    if (install.installed) return
    install.installed = true
    Vue.component('editor', KindEditor)
}

export default install



// WEBPACK FOOTER //
// ./src/plugin/kindeditor.js